import { Injectable } from '@angular/core';
import { EmpresaService } from 'app/main/a2w/supervisor/cadastros/empresas/empresa.service';

@Injectable({
    providedIn: 'root'
})
export class ConfigVersion {

    public versionPlataforma = '1.78.1';
    /*
    *
    *
    *
    *
    *
    *
    *
    *
    *
    *
    *
    * 
    * 
    * 
    */
    // Variável responsável pela configuração
    versionActive = false; // SE TRUE MOSTRARA APENAS O PRIMEIRO NOME -  SE FALSE MOSTRARA O NOME INTEIRO
    clienteSelecionado = 0;
    static tempoMesesDashboard = 0;
    temMatriz = false;

    cliente: any = [
        { // #0
            nome: '',
            cnpj: '',
            rua: '',
            numero: '',
            cep: '',
            cidade: '',
            uf: '',
            // logo: 'https://a2wplataforma.com.br/static/site/img/logo_a2w_rel.png',
            logo: '/assets/images/logos/logo_a2w_rel.png',
            account: ''
        }
    ];

    clienteBase: any = [
        // cliente: any = [
        { // #0
            nome: 'A2W PLATAFORMA AGRO',
            cnpj: '37.681.086/0001-75',
            rua: 'RUA GENERAL COSTA CAMPOS',
            numero: '64',
            cep: '37130-131',
            cidade: 'ALFENAS',
            uf: 'MG',
            logo: '',
            account: 'D5F9A959-A5EA-4114-EC5D-08DA0063F72D'
        },
        { // #1
            nome: 'ADUBOS REAL S.A - MATRIZ',
            cnpj: '21.437.447/0001-00',
            rua: 'AV. PINTO COBRA',
            numero: '780',
            cep: '37554-290',
            cidade: 'POUSO ALEGRE',
            uf: 'MG',
            // logo: 'https://a2wplataforma.com.br/static/site/img/logo_adubos_rel.png',
            logo: '',
            account: 'C117B9E9-B155-4741-2662-08D85083ADF9'
        },
        /* { //#2
            nome: 'ATUA AGRO',
            cnpj: '00.000.000/0000-00',
            rua: 'ROD. PR 090',
            numero: '5685',
            cep: '86200-000',
            cidade: 'IBIPORA',
            uf: 'PR',
            //logo: 'https://a2wplataforma.com.br/static/site/img/logo_atuaagro_rel.png',
            logo: '/assets/images/logos/logo_atuaagro_rel.png',
            account: ''
        },
        { //#3
            nome: 'ACERO',
            cnpj: '00.000.000/0000-00',
            rua: 'Rua Dorvelino',
            numero: '271',
            cep: '35534-000',
            cidade: 'CARMÓPOLIS DE MINAS',
            uf: 'MG',
            logo: '/assets/images/logos/logo_acero_rel.png',
            account: ''
        }, */
        { // #4
            nome: 'GEAGRO',
            cnpj: '00.000.000/0000-00',
            rua: 'Rua Ipiranga',
            numero: '1538',
            cep: '37190-000',
            cidade: 'Três Pontas',
            uf: 'MG',
            logo: '',
            account: 'C0A54B7C-5989-444E-71CF-08D9F536ABA4'
        },
        { // #5
            nome: 'PRIORI - ARMAZEM',
            cnpj: '12.067.326/0001-15',
            rua: 'ROD BR 364, KM 194 A ESQUERDA',
            numero: 'S/N',
            cep: '75800-001',
            cidade: 'Jataí',
            uf: 'GO',
            logo: '',
            account: 'ABBBCC32-A0A9-41F3-5F11-08D9CA311E8F'
        },
        { // #5
            nome: 'PROTEC',
            cnpj: '00.000.000/0000-00',
            rua: 'ENDERECO',
            numero: 'S/N',
            cep: '00000-000',
            cidade: 'CIDADE',
            uf: 'UF',
            logo: '',
            account: '0BD27CE3-9C68-4A31-1611-08D97D11628E'
        }
    ];

    constructor(
        private _empresaService: EmpresaService
    ) { }

    async buscaDadosCliente(accountId) {

        // VERIFICA SESSION
        // VERIFICA ACCOUNTID
        // BUSCA LISTA DE EMPRESAS DO ACCOUNTID
        this._empresaService.getAll()
            .then(res => {
                // console.log(res);
                for (let index = 0; index < res.length; index++) {
                    // console.log(res[index].linkRelatorio);
                    if (res[index].flagMatriz) {
                        this.cliente[0].nome = res[index].nomeFantasia;
                        this.cliente[0].cnpj = res[index].cnpj;
                        this.cliente[0].rua = res[index].enderecoLogradouro;
                        this.cliente[0].numero = res[index].numeroResid;
                        this.cliente[0].cep = res[index].cep;
                        this.cliente[0].cidade = res[index].cidade;
                        this.cliente[0].uf = res[index].uf;                        
                        this.cliente[0].logo = (res[index].linkRelatorio == '' || res[index].linkRelatorio == null)  ?  '/assets/images/logos/logo_a2w_rel.png' : res[index].linkRelatorio; 
                        this.cliente[0].account = res[index].accountId;
                        this.temMatriz = true;
                    }
                }

                if (!this.temMatriz) {
                    if (res.length > 0) {
                        this.cliente[0].nome = res[0].nomeFantasia;
                        this.cliente[0].cnpj = res[0].cnpj;
                        this.cliente[0].rua = res[0].enderecoLogradouro;
                        this.cliente[0].numero = res[0].numeroResid;
                        this.cliente[0].cep = res[0].cep;
                        this.cliente[0].cidade = res[0].cidade;
                        this.cliente[0].uf = res[0].uf;                        
                        this.cliente[0].logo = (res[0].linkRelatorio == '' || res[0].linkRelatorio == null)  ?  '/assets/images/logos/logo_a2w_rel.png' : res[0].linkRelatorio; 
                        this.cliente[0].account = res[0].accountId;
                    } else {
                        this.cliente[0] = this.clienteBase[0];
                    }
                }

            });

    }

    /* buscaLogo(accountId){
        
        console.log(accountId);
        // BUSCA O LOGO SE TIVER ACCOUNT VALIDO, SENAO, USA O LOGO DA A2W
        let logo = (this.clienteBase.find(x => x.account == toUpper(accountId))) ? this.clienteBase.find(x => x.account == toUpper(accountId)).logo : null;
        console.log(logo);
        if(logo != null){
            return logo;
        }else{
            return '/assets/images/logos/logo_a2w_rel.png';
        }
    }  */   
}
